import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createHandbooksStyles = ({ spacing, breakpoints }: Theme) => {
  return {
    root: css({
      position: "relative",
    }),
    heading: css({
      marginBottom: spacing(2),
    }),
    panelWrapper: css({
      display: "flex",
      flexDirection: "column",
      [breakpoints.up.sm]: {
        flexDirection: "row",
        justifyContent: "space-between",
      },
    }),
    uploadButton: css({
      maxWidth: 160,
      marginBottom: spacing(2),
      padding: spacing([0, 2]),
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      height: 200,
    }),
    emptyListText: css({
      textAlign: "center",
      marginBottom: spacing(2),
    }),
  };
};
